import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  selectTitle(event: Event) {
    const tag = event.currentTarget as HTMLElement;
    const title = tag.dataset.title;
    const input = document.getElementById("titles_fuzzysearch_input") as HTMLInputElement;

    if (input && title) {
      input.value = title;
      const form = input.closest("form") as HTMLFormElement;
      if (form) {
        form.requestSubmit();
      }
    }
  }
}
